import { Banner } from '@giftgroup/ui';
import { useSyncExternalStore } from 'react';
import { commonCopy } from '../copy/common';

function subscribe(onChange: () => void) {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

/**
 * There's no offline mode (doc 05): the honest thing is to say so, rather than show
 * stale lists. Claim data must never be served from a cache anyway.
 */
export function OfflineBanner() {
  const online = useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
  if (online) return null;
  return <Banner tone="warning">{commonCopy.offline}</Banner>;
}
